import React, { useState } from "react";
import Cities from "./Searchbar-Cities";
import Holder from "./Searchbar-Holder";

const data = [
  [
    "Agra",
    "Ahmedabad",
    "Ajmer",
    "Alappuzha",
    "Alibag",
    "Allahabad",
    "Amarja",
    "Ambala",
    "Amritsar",
    "Andaman and Nicobar",
    "Auli",
  ],
  [
    "Badrinath",
    "Bangalore",
    "Barog",
    "Barot",
    "Bekal",
    "Bangalore",
    "Bhagsunag",
    "Bhandardara",
    "Bhimtal",
    "Bhuntar",
    "Bir",
    "Bodh Gaya",
    "Boisa",
  ],
  ["Chandigarh", "Chikmagalur", "Coonor", "Coorg"],
  [
    "Dalhousie",
    "Daman",
    "Daman and Diu",
    "Darjeeling",
    "Dawki",
    "Dehradun",
    "Delhi",
    "Devas",
    "Devprayag",
    "Dhanaulti",
    "Dharampur",
    "Dharamshala",
  ],
  ["Erode"],
  ["Faridabad"],
  ["Goa", "Gurgaon"],
  ["Hisar", "Hamirpur", "Hassan"],
  ["Igatpuri", "Indore"],
  ["Jaipur", "Jaiselmer"],
  [
    "Kamshet",
    "Kanatal",
    "Karjat",
    "Kasauli",
    "Khopoli",
    "Kandhaghat",
    "Khandala",
    "Kodaikanal",
    "Kullu",
  ],
  ["Lonavala", "Lavassa", "Lansdowne"],
  [
    "Mabaleshwar",
    "Madikeri",
    "Manali",
    "Maldives",
    "Maount Abu",
    "Mulshi",
    "Mussoorie",
    "Mumbai",
  ],
  ["Nainital", "Nashik", "North Goa"],
  ["Ooty"],
  ["Pune", "Pawna", "Panchgani", "Pali", "Panvel", "Palgarh"],
  ["Q"],
  ["Ramnagar", "Raigad"],
  ["Shimla", "Siliguri", "Silvassa"],
  ["Talegaon", "Trimak"],
  ["Udaipur", "Uttan"],
  ["Vishakapatnam", "Vadodara", "Varkala", "Vagamon", "Vellore", "Varanasi"],
  ["Wada", "Wayand"],
  ["X"],
  ["Y"],
  ["Z"],
];

const Searchbar = () => {
  const [isHovering, setIsHovering] = useState("");

  const handleMouseOver = (e) => {
    setIsHovering(e);
  };
  const handleMouseOut = () => {
    setIsHovering("");
  };
  return (
    <>
      <div className=" invisible md:visible  flex flex-row justify-between mb-4 divide-x-[2px] divide-gray-800">
        {data.map((arr) => {
          return (
            <Holder
              isHovering={isHovering}
              handleMouseOver={handleMouseOver}
              handleMouseOut={handleMouseOut}
              cityNames={arr}
              alphabet={arr[0][0][0]}
            />
          );
        })}
      </div>

      {data.map((arr, i) => {
        // return (<Holder isHovering={isHovering} handleMouseOver={handleMouseOver} handleMouseOut={handleMouseOut} cityNames={arr} alphabet={arr[0][0][0]} />)
        return (
          <>
            {isHovering === arr[0][0][0] && (
              <Cities
                cityNames={arr.slice(0,3)}
                citylength={arr.length}
                isHovering={isHovering}
                handleMouseOut={handleMouseOut}
                handleMouseOver={handleMouseOver}
                x={i * 3.40384615}
              />
            )}
          </>
        );
      })}
    </>
  );
};

export default Searchbar;
